import { useState, useEffect, useCallback } from 'react';
import { Candidate } from '@recruitai/shared';
import { apiClient } from '../lib/api-client';

interface GetCandidateResponse {
  candidate: Candidate;
  resumeDownloadUrl?: string;
}

interface UseCandidateResult {
  candidate: Candidate | null;
  resumeDownloadUrl?: string;
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
  setCandidate: (candidate: Candidate) => void;
}

export function useCandidate(jobId: string, candidateId: string): UseCandidateResult {
  const [candidate, setCandidate] = useState<Candidate | null>(null);
  const [resumeDownloadUrl, setResumeDownloadUrl] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchCandidate = useCallback(async () => {
    if (!jobId || !candidateId) return;
    try {
      setIsLoading(true);
      setError(null);

      const response = await apiClient.get<GetCandidateResponse>(
        `/jobs/${jobId}/candidates/${candidateId}`
      );
      setCandidate(response.candidate);
      setResumeDownloadUrl(response.resumeDownloadUrl);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Falha ao carregar candidato'));
    } finally {
      setIsLoading(false);
    }
  }, [jobId, candidateId]);

  useEffect(() => {
    fetchCandidate();
  }, [fetchCandidate]);

  return { candidate, resumeDownloadUrl, isLoading, error, refetch: fetchCandidate, setCandidate };
}
